module.exports = __webpack_public_path__ + "img/chevron-left.6b8c5aec.svg";